var $593968e201fe3198$exports = {};
function $593968e201fe3198$var$formatDayWithOrdinalSuffix(day) {
    if (day >= 11 && day <= 13) return day + 'th';
    switch(day % 10){
        case 1:
            return day + 'st';
        case 2:
            return day + 'nd';
        case 3:
            return day + 'rd';
        default:
            return day + 'th';
    }
}
function $593968e201fe3198$var$getNextWorkday() {
    const daysOfWeek = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    const today = new Date();
    const dayOfWeek = today.getDay();
    // Calculate the offset to the next workday
    let offset = 1; // Default to next day (Monday to Friday)
    if (dayOfWeek === 5) offset = 3; // Set to next Monday
    else if (dayOfWeek === 6) offset = 2; // Set to next Monday
    // Calculate the next workday
    const nextWorkday = new Date(today);
    nextWorkday.setDate(today.getDate() + offset);
    const dayName = daysOfWeek[nextWorkday.getDay()];
    const dayOfMonth = $593968e201fe3198$var$formatDayWithOrdinalSuffix(nextWorkday.getDate());
    return `${dayName} ${dayOfMonth}`;
}
const $593968e201fe3198$var$nextWorkdayFormatted = $593968e201fe3198$var$getNextWorkday();
console.log("Next workday:", $593968e201fe3198$var$nextWorkdayFormatted);
// Get all elements by their data-id attribute
const $593968e201fe3198$var$nextSlotElements = document.querySelectorAll('[data-id="next-slot"]');
if ($593968e201fe3198$var$nextSlotElements.length > 0) $593968e201fe3198$var$nextSlotElements.forEach((element)=>{
    element.textContent = $593968e201fe3198$var$nextWorkdayFormatted;
});
else console.error("Elements not found with data-id 'next-slot'");
/* USING WINDOW. IN FRONT OF GTAG TO FIX PARCEL MINIMISATION */ window.fireConversion = function fireConversion() {
    gtag('event', 'conversion', {
        'send_to': 'AW-11166055251/BVKtCOXjoN0YENP2scwp'
    });
    // Optionally, you can add additional code here to handle the click behavior.
    console.log('conversion');
};
/* DONT NEED IT?!

function setupZoomer() {
  const zoomerBoxes = document.querySelectorAll('.img-zoomer-box');

  zoomerBoxes.forEach(zoomerBox => {
    const originalImage = zoomerBox.querySelector('.img-1');
    let magnifiedImage = document.createElement('div');
    magnifiedImage.className = 'img-2';
    magnifiedImage.style.backgroundImage = `url('${originalImage.src}')`;
    originalImage.parentNode.insertBefore(magnifiedImage, originalImage.nextSibling);

    // Mousemove event to handle zoom effect
    zoomerBox.addEventListener('mousemove', function (e) {
      const style = magnifiedImage.style;
      
      // Get up-to-date position of the zoomerBox using getBoundingClientRect
      const rect = this.getBoundingClientRect();
      const x = e.clientX - rect.left; // Use clientX and rect for dynamic positioning
      const y = e.clientY - rect.top;
      const imgWidth = originalImage.offsetWidth;
      const imgHeight = originalImage.offsetHeight;

      // Calculate percentage for background positioning
      let xperc = ((x / imgWidth) * 100);
      let yperc = ((y / imgHeight) * 100);

      if (x > 0.01 * imgWidth) {
        xperc += 0.15 * xperc;
      }

      if (y >= 0.01 * imgHeight) {
        yperc += 0.15 * yperc;
      }

      // Set the background position of the magnified image
      style.backgroundPositionX = xperc - 9 + '%';
      style.backgroundPositionY = yperc - 9 + '%';

      // Set the position of the magnified image relative to the mouse
      style.left = x - 180 + 'px';
      style.top = y - 180 + 'px';
    }, false);
  });
}

// Call the setupZoomer function on page load
setupZoomer();

*/ // A simple hash function for demonstration purposes
function $593968e201fe3198$var$simpleHash(s) {
    let hash = 0;
    for(let i = 0; i < s.length; i++){
        const char = s.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
function $593968e201fe3198$var$checkCssFeature(feature) {
    return CSS.supports(feature);
}
function $593968e201fe3198$var$checkApiAvailability(api) {
    return window[api] !== undefined;
}
function $593968e201fe3198$var$prefersDarkMode() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
}
function $593968e201fe3198$var$hasTouchSupport() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function $593968e201fe3198$var$getScreenProperties() {
    return {
        width: screen.width,
        height: screen.height,
        colorDepth: screen.colorDepth
    };
}
function $593968e201fe3198$var$generateUID() {
    const userAgent = navigator.userAgent;
    const language = navigator.language;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const darkMode = $593968e201fe3198$var$prefersDarkMode() ? 'dark' : 'light';
    const touchSupport = $593968e201fe3198$var$hasTouchSupport() ? 'touch' : 'no-touch';
    const screenProps = $593968e201fe3198$var$getScreenProperties();
    const cssGridSupport = $593968e201fe3198$var$checkCssFeature('display: grid') ? 'grid' : 'no-grid';
    const uidSource = `${userAgent}-${language}-${timeZone}-${darkMode}-${touchSupport}-${screenProps.width}x${screenProps.height}-${screenProps.colorDepth}-${cssGridSupport}`;
    const uid = $593968e201fe3198$var$simpleHash(uidSource);
    return uid;
}
document.addEventListener('DOMContentLoaded', function() {
    // Send page view event
    const bodyLabel = document.body.getAttribute('data-event-label');
    if (bodyLabel) sendMessage('View', '', bodyLabel); // 'group' is empty for page views
    // Handle button clicks
    const buttons = document.querySelectorAll('[data-event-type="Click"]');
    buttons.forEach((button)=>{
        button.addEventListener('click', function() {
            const type = button.getAttribute('data-event-type');
            const group = button.getAttribute('data-event-group');
            const label = button.getAttribute('data-event-label');
            sendMessage(type, group, label);
        });
    });
});
window.sendMessage = function sendMessage1(type, group, label) {
    const UID = $593968e201fe3198$var$generateUID(); // Existing UID generation
    const currentURL = window.location.href; // Capture the current URL
    fetch('/.netlify/functions/sendMessage', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            UID: UID,
            type: type,
            group: group,
            label: label,
            url: currentURL
        })
    }).then((response)=>{
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
    }).then((data)=>console.log('Message sent successfully:', data)).catch((error)=>console.error('Error:', error));
};
// // Using require
// const hljs = require('highlight.js/lib/core');
// // Load any languages you need
// hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
// // Copy code buttons
// const copyButtonLabel = "Copy Code";
// // use a class selector if available
// let blocks = document.querySelectorAll("pre");
// blocks.forEach((block) => {
//   // only add button if browser supports Clipboard API
//   if (navigator.clipboard) {
//     let button = document.createElement("button");
//     button.innerText = copyButtonLabel;
//     block.appendChild(button);
//     button.addEventListener("click", async () => {
//       await copyCode(block);
//     });
//   }
// });
// async function copyCode(block) {
//   let code = block.querySelector("code");
//   let text = code.innerText;
//   await navigator.clipboard.writeText(text);
// }
document.querySelectorAll('details').forEach((elem)=>{
    elem.addEventListener('toggle', function(event) {
        if (this.open) // Close all other details elements
        document.querySelectorAll('details').forEach((otherElem)=>{
            if (otherElem !== this) otherElem.removeAttribute('open');
        });
    });
});
document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll('body *:not(.img-zoomer-box)'); // Exclude zoomer boxes
    const options = {
        threshold: 0.1
    };
    const observer = new IntersectionObserver((entries, observer)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target);
            }
        });
    }, options);
    elements.forEach((element)=>{
        observer.observe(element);
    });
});
document.addEventListener("DOMContentLoaded", function() {
    let lastScrollTop = 0;
    window.addEventListener('scroll', function() {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll > lastScrollTop) {
            // Scrolling down
            document.body.classList.remove('scroll-up');
            document.body.classList.add('scroll-down');
        } else {
            // Scrolling up
            document.body.classList.remove('scroll-down');
            document.body.classList.add('scroll-up');
        }
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Ensure it doesn't go negative
    }, false);
});


//# sourceMappingURL=developers-migrating-airtable.1d99220a.js.map
